/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTip.vue?vue&type=template&id=43e7710d&scoped=true"
import script from "./popAirdropTip.vue?vue&type=script&lang=js"
export * from "./popAirdropTip.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTip.vue?vue&type=style&index=0&id=43e7710d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e7710d",
  null
  
)

export default component.exports